// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2AzdK{color:#2a343e}", ""]);
// Exports
exports.locals = {
	"fileError__headingText": "_2AzdK"
};
module.exports = exports;
